// src/firebase.js
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { getFunctions } from "firebase/functions";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";
// Your web app's Firebase configuration from the file you provided
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  // Firebase Analytics (GA4) measurement ID, e.g. "G-XXXXXXX"
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export the services you need
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const database = getDatabase(app);
// Initialize Functions with region (us-central1 is the default)
export const functions = getFunctions(app, 'us-central1');

// ---- Analytics (Google Analytics / GA4 via Firebase) ----
let analyticsInitPromise = null;

export function isAnalyticsAllowed() {
  if (typeof window === "undefined") return false;
  // default: enabled unless user explicitly opts out
  return window.localStorage.getItem("logami_analytics_consent") !== "false";
}

export async function getFirebaseAnalytics() {
  if (typeof window === "undefined") return null;
  if (!firebaseConfig.measurementId) return null;
  if (!isAnalyticsAllowed()) return null;
  // Skip Analytics on localhost to avoid 400 from Firebase (API key referrer restrictions)
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  if (hostname === "localhost" || hostname === "127.0.0.1") return null;

  if (analyticsInitPromise) return analyticsInitPromise;

  analyticsInitPromise = (async () => {
    try {
      const supported = await isSupported();
      if (!supported) return null;
      return getAnalytics(app);
    } catch (err) {
      console.warn("Firebase Analytics init failed:", err);
      return null;
    }
  })();

  return analyticsInitPromise;
}

export async function trackEvent(eventName, params = {}) {
  const analytics = await getFirebaseAnalytics();
  if (!analytics) return;

  try {
    logEvent(analytics, eventName, params);
  } catch (err) {
    console.warn("Firebase Analytics logEvent failed:", err);
  }
}